import type { GetStaticPaths, GetStaticProps } from 'next';
import Home from '../../index';
import { getHomeStaticPropsBySite } from '../../../lib/server/site-props';

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = getHomeStaticPropsBySite;

export default Home;

